import {
    FeatureWrap,
    LanguagePicker,
    Modal,
    ModalTabs,
    PDFRenderer,
    Show,
} from "components";
import { useMatch, useSearch } from "react-location";
import { useOffer, useOfferParticipant } from "hooks/data/use-offers";

import { LocationGenerics } from "router/location";
import config from "config";
import { processUrlData } from "utils/url";
import { useFormik } from "formik";
import { useState } from "react";
import { currentUserVar } from "_graphql/cache/auth";
import SignedPlacingSlipViewer from "components/forms/slip-wizard/signed-placing-slip-viewer";

const tabs = [
    {
        name: "Closing Note",
        href: "CLOSING_NOTE",
    },
    {
        name: "Signed Placing Slip",
        href: "SIGNED_SLIP",
        country: "ghana",
    },
];

export default function ViewNoteContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const form = useFormik({
        initialValues: {
            lang: "en",
        },
        onSubmit(values, formikHelpers) {},
    });
    const searchParams = useSearch<LocationGenerics>();
    const currentUser = currentUserVar();
    const { params } = useMatch<LocationGenerics>();
    const [orderStatus, setOrderStatus] = useState("CLOSING_NOTE");
    const { loading, offer } = useOffer({
        offer_id: params?.offer || "",
    });

    const { loading: fetchingParticipant, participant } = useOfferParticipant({
        participantId: searchParams?.id || "",
    });

    const closingNoteUrl = `${config.asset.uri}generate_closing_slip/${processUrlData({
        offer_id: params?.offer || "",
        reinsurer_id: participant?.reinsurer.reinsurer_id,
        period_from: offer?.offer_detail?.period_of_insurance_from,
        period_to: offer?.offer_detail?.period_of_insurance_to,
        lang: form.values.lang,
        companyName:
            currentUser?.employee?.broker_config?.broker_company_name || "",
        brokerConfigId:
            currentUser?.employee?.broker_config?.broker_configuration_id,
        ...currentUser?.employee?.broker_config?.broker_address,
    })}`;

    const reinsurerId = participant?.reinsurer?.reinsurer_id || "";

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={loading || fetchingParticipant}
            hideActions
            size="6xl"
            title="Closing Note and Signed Slip"
            description="View Closing Note and Signed Slip">
            <ModalTabs
                tabs={tabs}
                orderStatus={orderStatus}
                setOrderStatus={setOrderStatus}
            />
            <div className="p-3">
                <Show if={orderStatus === "CLOSING_NOTE"}>
                    <div className="mb-3">
                        <LanguagePicker id={"lang"} labelHidden {...form} />
                    </div>
                    <PDFRenderer url={closingNoteUrl} />
                </Show>
                <Show if={orderStatus === "SIGNED_SLIP"}>
                    <SignedPlacingSlipViewer
                        offerId={params?.offer || ""}
                        reinsurerId={reinsurerId}
                        enabled={open && orderStatus === "SIGNED_SLIP"}
                    />
                </Show>
            </div>
        </Modal>
    );
}
